export const moviesBatchDelete = (store) => (
  store.loadOptions('films_parent_id', '/films?attrs=["id", "parent_id", "title"]').then(() => {
    return Promise.resolve(store.requester.call(`/contractitems`))
      .then(res => res.data).then(contractitems => {
        const underContract = store.cv.selection.map(s =>
          contractitems.find(ci => ci.film_id === store.cv.items[s].id)
        ).filter(i => i)
        const isParent = store.cv.selection.map(s =>
          store.options.get('films_parent_id').find(ci => ci.parent_id && ci.parent_id === store.cv.items[s].id)
        ).filter(i => i)
        if (underContract.length > 0) {
          store.addMessage(
            store.__('You are trying to remove film assigned to CONTRACT').concat(' ') +
            underContract.map(i => i.title).join(', ').concat('. ') +
            store.__('First unassign the film from the contract and try again.'),
            'error',
            8000
          )
        }
        if (isParent.length > 0) {
          store.addMessage(
            store.__('You are trying to remove item assigned as SERIES.').concat(' ') +
            store.__('First unassign all episodes from the film and try again.'),
            'error',
            8000)
        }
        if (!underContract.length && !isParent.length) {
          window.confirm(store.__('Really delete selected items?')) && store.cv.deleteSelected()
            .then(() => store.addMessage(store.__('Selected items removed.')))
            .catch(store.onRequesterError.bind(store))
        }
      }).catch(store.onRequesterError.bind(store))
  })
)
